// extracted by mini-css-extract-plugin
export var clauseRow = "_49-6";
export var emptyState = "_49-b";
export var filterContent = "_49-a";
export var filterGroup = "_49-1";
export var filterGroupContainer = "_49-0";
export var nestedGroup = "_49-2";
export var nestedGroupDepth1 = "_49-3";
export var nestedGroupDepth2 = "_49-4";
export var nestedGroupDepth3 = "_49-5";
export var operatorAnd = "_49-8";
export var operatorOr = "_49-9";
export var operatorToggle = "_49-7";
export var removeGroupButton = "_49-c";